import * as React from 'react';
import { toPathOptions } from '../utils/treeUtil';
export default (function (options, fieldNames) {
  return React.useCallback(function (rawValues) {
    var missingValues = [];
    var existsValues = [];
    rawValues.forEach(function (valueCell) {
      var pathOptions = toPathOptions(valueCell, options, fieldNames);
      if (pathOptions.every(function (opt) {
        return opt.option;
      })) {
        existsValues.push(valueCell);
      } else {
        missingValues.push(valueCell);
      }
    });
    return [existsValues, missingValues];
  }, [options, fieldNames]);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/kts-components/node_modules/rc-cascader/es/hooks/useMissingValues.js
// module id = 4616
// module chunks = 0